import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, compact: PropTypes.bool };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'ul',
    compact: false,
};

class List extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            compact,
        } = this.props;
        return [
            'c-list',
            compact ? 'c-list--compact' : null,
            className,
        ];
    }

}

List.propTypes = propTypes;

List.defaultProps = defaultProps;

export default List;
